import React, { useEffect } from 'react';

import { Subject } from '../../../clients/AnalyticsClient';
import { AnalyticsConsumerProps, withAnalytics } from '../../../hoc/withAnalytics';

export type RenderTrackerProps = AnalyticsConsumerProps & {
  subject: Subject;
  success?: true;
};

const RenderTracker: React.FC<RenderTrackerProps> = ({ analytics, success, subject }) => {
  useEffect(() => {
    // TODO: replace this with UFO
    // if (success) {
    //   metrics.ui.endSuccess(task);
    // } else {
    //   metrics.ui.endWithError(task, 'COMPONENT');
    // }
    analytics.trackOperational(subject, success === true ? 'success' : 'failed');
  }, []);
  return <React.Fragment />;
};

export default withAnalytics(RenderTracker);
